/*eslint-disable */
const $ = window.jQuery = require('jquery');

import aboutOfUserInfo from '@/components/private/user/about-of-user-info/index.vue';
import addAboutOfUserInfo from '@/components/private/user/add-about-of-user-info/index.vue';
import axios from 'axios';
import blogList from '@/components/private/blog/list.vue';
import { bus } from '@/main';
import countries from '@/services/country.json'
import demoRequestsList from '@/components/private/demoRequests/list.vue';
import fullBioPopup from '@/components/private/dashboard/full-bio-for-popup/';
import { mapGetters } from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'home-dashboard',
  components: {
    'about-user-info': aboutOfUserInfo,
    'add-about-user-info': addAboutOfUserInfo,
    'full-bio-popup': fullBioPopup,
    'blog-list': blogList,
    'demo-requests-list': demoRequestsList
  },
  props: [],
  data() {
    return {
      userDetails: null,
      loadmoreData: {},
      userLoading: false,
      nextStep: '',
      bioFullData: '',
      bioFullDataPopup: false,
      selfUserId: '',
      blogActv: 'blog',
      countryList: [],
      aboutUserInfoPopupState: false,
      getAboutInfo: '',
      addAboutPopupState: false,
      isMobile: false,
      file: null,
      myCvReUploadSection: false,
      cvUploadLoader: false
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters',
      'getAboutDetailsOfProfileGetters'
    ]),
    getUserDetailsAgainFun() {
      this.userDetails = this.$store.getters.acUserDetailsStateGetters.data;
      return;
    },
    getAboutInfoFun() {
      this.getAboutInfo = this.$store.getters.getAboutDetailsOfProfileGetters.data;
      return;
    }
  },
  mounted() {
    if (localStorage.getItem('LoginedUserID')) {
      this.selfUserId = localStorage.getItem('LoginedUserID');
    }
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1);
    this.getUserDetailsAgainFun;
    this.getAboutInfoFun;
    bus.$on('aboutUserInfoPopupStateBus', (data) => {
      this.aboutUserInfoPopupState = data;
      this.myCvReUploadSection = false;
    });
    bus.$on('addAboutPopupStateBus', (data) => {
      this.addAboutPopupState = data;
      this.myCvReUploadSection = false;
    });
    bus.$on('bioFullDataPopupBus', (data) => {
      this.bioFullDataPopup = data;
    });
  },
  methods: {
    downloadFile(url, filename) {
      const xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function () {
        const url = URL.createObjectURL(this.response);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      };
      xhr.open('GET', url);
      xhr.send();
    },
    deleteCvFromMyBucketMethod() {
      this.$store.dispatch('deleteCVbyUserIdAction').then((res) => {
        toast.success("Cv deleted has been successfully");
        this.myCvReUploadSection = false
        this.$store.dispatch('getAboutDetailsOfProfileFun')
      }).catch((err) => {
      })
    },
    cvTabChangedMethod() {
      if (this.myCvReUploadSection == true) {
        this.myCvReUploadSection = false
      } else {
        this.myCvReUploadSection = true
      }
    },
    handleReuploadCvUploadMethod(event) {
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        this.file = event.target.files[0];
        this.$store.dispatch('deleteCVbyUserIdAction').then((res) => {
          var formData = new FormData();
          formData.append('cv', this.file);
          formData.append('cv_filename', file.name);
          formData.append('pdf_cv', this.file);
          this.cvUploadLoader = true;
          this.$store.dispatch('uploadUsrCVAction', formData).then((res) => {
            toast.success(res.data.msg);
            this.cvUploadLoader = false;
            this.$store.dispatch('getAboutDetailsOfProfileFun')
          }).catch((err) => {
            this.cvUploadLoader = false;
            this.file = null
          })
        })
      }
    },
    handleCVUploadMethod(event) {
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        this.file = event.target.files[0];
        var formData = new FormData();
        formData.append('cv', this.file);
        formData.append('cv_filename', file.name);
        formData.append('pdf_cv', this.file);
        this.cvUploadLoader = true;
        this.$store.dispatch('uploadUsrCVAction', formData).then((res) => {
          toast.success(res.data.msg);
          this.cvUploadLoader = false;
          this.$store.dispatch('getAboutDetailsOfProfileFun')
        }).catch((err) => {
          this.cvUploadLoader = false;
          this.file = null
        })
      }
    },
    onResize() {
      this.isMobile = window.innerWidth < 769
    },
    openAddAboutPopup() {
      document.body.classList.add('body_right_scroll_remove');
      this.addAboutPopupState = true
    },
    openUpdateAboutPopup() {
      document.body.classList.add('body_right_scroll_remove');
      this.aboutUserInfoPopupState = true
    },
    getHtmlValOfEditor(htmlString) {
      var stripedHtml = $("<div>").html(htmlString).text();
      // var newStripedHtml = stripedHtml.replace(':', /(\n)/g)
      var customItems = stripedHtml.split(":");
      for (let i = 0; i < customItems.length; i++) {
        customItems[i] = customItems[i] + "\n";
      }
      customItems = customItems.join("");
      return customItems;
    },
    homeFilterFun(checkItem, param) {
      $('.total_count_box').removeClass('active');
      $('#homeFilterTab' + param).addClass('active');
      this.blogActv = checkItem
    },
    bioReadMoreFun(data) {
      this.bioFullData = data
      this.bioFullDataPopup = true
      document.body.classList.add('body_right_scroll_remove');
    },
    showLoadMoreDataFun(url) {
      this.userLoading = true
      console.log(url, "Next URL LINK")
      axios.get(url).then((response) => {
        console.log(response.data.data.next)
        this.loadmoreData = response.data
        this.nextStep = this.loadmoreData.data.next
        this.$set(this.userUpdatesList, 'next', this.nextStep)
        if (this.loadmoreData != undefined) {
          for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
            this.userUpdatesList.push(this.loadmoreData.data.results[i]);
            this.userLoading = false
          }
        }
      });
    },
    getUserDetailsAgain() {
      this.$store.dispatch('getAcUserDetailsFun').then((res) => {
        this.userDetails = res.data.data
      }).catch((err) => {
      })
    },
    userStatusUpdatedFun(userDetails, userStatus) {
      var is_public = userStatus
      if (userStatus == false) {
        is_public = true
      } else {
        is_public = false
      }
      let data = new FormData();
      data.append('is_public', is_public);
      this.$store.dispatch('updateProfileFun', data)
        .then((res) => {
          toast.success(res.data.msg);
          this.getUserDetailsAgain()
        }).catch((err) => {
          toast.error(err.data.user_msg || err.data.data.email);
        })
      return;
    },
    getCountryName(countryCode) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        country = country.name
      } else {
        country = ''
      }
      return country;
    },
  },
  watch: {
    getUserDetailsAgainFun() {
      return this.$store.getters.acUserDetailsStateGetters;
    },
    getAboutInfoFun() {
      return this.$store.getters.getAboutDetailsOfProfileGetters;
    }
  },
  beforeRouteLeave: function (to, from, next) {
    document.body.classList.remove('body_right_scroll_remove');
    next();
  },
  created() {
    window.addEventListener('resize', this.onResize, { passive: true });
    this.onResize();
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true });
    }
  },
}